import { Box, Input } from '@chakra-ui/react';
import SelectInput from 'components/inputs/SelectInput';
import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';
import {
  isUsCountry,
  US_STATE_CODES,
  US_STATE_SELECT_OPTIONS,
} from '../constants/usStates';

const CUSTOM_STATE_VALUE = '__custom__';

const BillingStateField = forwardRef(({ country, value, onChange, onBlur, name }, ref) => {
  const isUnitedStates = isUsCountry(country);
  const normalizedValue = value ? String(value).trim() : '';
  const valueInList = US_STATE_CODES.has(normalizedValue);
  const [useCustomInput, setUseCustomInput] = useState(
    Boolean(normalizedValue && !valueInList)
  );

  useEffect(() => {
    if (!isUnitedStates) {
      setUseCustomInput(false);
      return;
    }
    if (normalizedValue && !US_STATE_CODES.has(normalizedValue)) {
      setUseCustomInput(true);
    }
  }, [isUnitedStates, normalizedValue]);

  if (!isUnitedStates) {
    return (
      <Input
        ref={ref}
        name={name}
        value={normalizedValue}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        placeholder="State / region"
      />
    );
  }

  const selectValue = useCustomInput ? CUSTOM_STATE_VALUE : normalizedValue;

  return (
    <Box>
      <SelectInput
        enableSearch
        options={US_STATE_SELECT_OPTIONS}
        value={selectValue || null}
        placeholder="Select US state"
        onChange={(selectedValue) => {
          if (selectedValue === CUSTOM_STATE_VALUE) {
            setUseCustomInput(true);
            onChange('');
            return;
          }
          setUseCustomInput(false);
          onChange(selectedValue || '');
        }}
      />
      {useCustomInput ? (
        <Input
          ref={ref}
          name={name}
          mt={2}
          value={normalizedValue}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          placeholder="Enter state manually"
        />
      ) : null}
    </Box>
  );
});

BillingStateField.displayName = 'BillingStateField';

BillingStateField.propTypes = {
  country: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  name: PropTypes.string,
};

export default BillingStateField;
